module.exports = __webpack_public_path__ + "static/media/favebiz-financing.5d973fae.jpg";